import {PaginationDto} from "../../common/dto/PaginationDto";

export class RequestVisitorSearchCondition extends PaginationDto {
    requestNumber: string = '';
    arriveDateFrom?: string = '';//dayjs().format(Formats.DATE_SIMPLE);
    arriveDateTo?: string = '';// dayjs().format(Formats.DATE_SIMPLE);
    visitorName: string = '';
    visitorMobile: string = '';
    visitorEmail: string = '';
    visitorIdNumber: string = '';
    visitorCompany: string = '';
    visitCode: string = '';
    hostName: string = '';
    hostMobile: string = '';
    hostEmail: string = '';
    statusList: Array<string> = [];
    status: string = '';
    hostStaffNumber: string = '';
    siteId: string = '';
    visitorStatus: string = '';
    sortField: string = '';
    sortType: string = '';
    hostDepartmentName: string = '';
    accessCardNumber: string = '';
    requestClassify: string = '';
    constructionOrderNumber: string = '';
    pageSize: number = 10;
    wxOpenId: string = '';
}
